import { useEffect, useState } from 'react';

import { OPEN_QUERY_PARAM_VALID_VALUES } from '../constants';
import { getOpenQueryParam } from '../utils';

export const useOpenQueryParam = () => {
  const [param, setParam] = useState<string>();
  useEffect(() => {
    const queryParam = getOpenQueryParam() ?? '';
    if (OPEN_QUERY_PARAM_VALID_VALUES.includes(queryParam)) {
      setParam(queryParam);
    }
  }, []);

  return param;
};
